// extracted by mini-css-extract-plugin
export var dropdownButton = "_34-0";
export var fullWidthDropdownButton = "_34-1";
export var icon = "_34-3";
export var iconPlaceholder = "_34-2";
export var menuItemRow = "_34-8";
export var separator = "_34-c";
export var shortcutContainer = "_34-7";
export var shortcutIconLg = "_34-6";
export var shortcutIconMd = "_34-5";
export var shortcutIconSm = "_34-4";
export var submenuChevron = "_34-b";
export var submenuDropdown = "_34-9";
export var submenuTriggerRow = "_34-a";